import * as Yup from 'yup'
import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import { intArraySchema } from '../../../common/schemas/intArraySchema'

type Values = {
  name: string
  pageNumbers: string
  useDefault?: boolean
}

type Props = {
  values: Values | null
  errors: Partial<Record<keyof Values, string>>
  touched: Partial<Record<keyof Values, boolean>>
  handleBlur: React.FocusEventHandler<HTMLElement>
  handleChange: React.ChangeEventHandler<HTMLElement>
  handleSubmit: React.SubmitEventHandler<HTMLFormElement>
  isSettingWritable: boolean
  title: string
  submitButtonText: string
  onClickCancel: () => void
}

const _UpsertArticleRulesGroupForm = ({
  values,
  errors,
  touched,
  handleBlur,
  handleChange,
  handleSubmit,
  isSettingWritable,
  title,
  submitButtonText,
  onClickCancel
}: Props) => {
  if (!values) {
    return <></>
  }
  return (
    <>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Form noValidate onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group as={Row} className='mb-3'>
            <Form.Label column className='col-3'>
              組版ルールグループ名称
            </Form.Label>
            <Col>
              <Form.Control
                type='text'
                name='name'
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!(touched.name && errors.name)}
              />
              <Form.Control.Feedback type='invalid' className='invalid-feedback-name'>
                {errors.name}
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column className='col-3'>
              対象ページ
            </Form.Label>
            <Col>
              <Form.Control
                id='pageNumbersInput'
                type='text'
                name='pageNumbers'
                value={values.pageNumbers}
                placeholder='入力例：1, 2, 3'
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!(touched.pageNumbers && errors.pageNumbers)}
                disabled={!isSettingWritable || values.useDefault}
              />
              <Form.Control.Feedback type='invalid' className='invalid-feedback-pageNumbers'>
                {errors.pageNumbers}
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={onClickCancel}>
            キャンセル
          </Button>
          <Button type='submit'>{submitButtonText}</Button>
        </Modal.Footer>
      </Form>
    </>
  )
}

export const UpsertArticleRulesGroupForm = Object.assign(_UpsertArticleRulesGroupForm, {
  schema: Yup.object().shape({
    name: Yup.string().required(),
    pageNumbers: intArraySchema.required()
  })
})
